import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { HealthCheck, HealthCheckCreate, HealthCheckFilter } from '../data/healthCheck';

export function createHealthCheckService(client: AxiosInstance) {
  return createCrudService<HealthCheck, HealthCheckCreate, HealthCheckFilter>(
    client,
    '/platform/HealthCheck',
    'id',
  );
}

export type HealthCheckService = CrudService<HealthCheck, HealthCheckCreate, HealthCheckFilter>;
